export default __webpack_public_path__ + "static/Gilead_worldaidsday_1-931adcfd959d21d08d596cf2826c91fe.jpg";